import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';
import installBlocks from './config/blocks';
import installViews from './config/views';
import installWidgets from './config/widgets';
import installValidators from './config/validators';
import * as addonReducers from './reducers';

import socialNetworksSVG from '@plone/volto/icons/link.svg';

function applyConfig(config: ConfigType) {
  installSettings(config);
  installBlocks(config);
  installViews(config);
  installWidgets(config);
  installValidators(config);

  // Registra reducers do addon
  config.addonReducers = {
    ...config.addonReducers,
    ...addonReducers,
  };

  // Os guards de slot evitam erro/duplicação se o applyConfig re-executar (HMR)
  const belowContent = config.getSlotComponents('belowContent');

  // O layout não prevê a lista de tags no fim das páginas de conteúdo
  // (o core a registra no slot belowContent para todos os tipos)
  if (belowContent.includes('tags')) {
    config.unRegisterSlotComponent('belowContent', 'tags', 0);
  }

  // Ícone do painel de redes sociais no control panel Volto
  config.settings.controlPanelsIcons = {
    ...config.settings.controlPanelsIcons,
    'social-networks-properties': socialNetworksSVG,
  };

  return config;
}

export default applyConfig;
